// CodeKhmerLearning Community palette.
//
// The community itself is **one colour: blue** (CodeKhmerLearning). Orange is
// the Mini Shop colour and is used on the Mini Shop pages only — the `/shops`
// directory, shop cards and the "open your own MiniShop shop" plans — where the
// page deliberately mixes blue + orange.
export const BLUE = '#0B5FDB';        // CodeKhmerLearning blue — community primary
export const BLUE_SOFT = '#3B82F6';
export const BLUE_DARK = '#083E93';
export const ORANGE = '#FB6E08';      // Mini Shop orange — shops pages only

// Back-compat aliases: older components import NAVY / NAVY_SOFT.
export const NAVY = BLUE;
export const NAVY_SOFT = BLUE_DARK;
export const BRAND = { blue: BLUE, orange: ORANGE, navy: BLUE };

/** Brand name shown on the first page / navbar / footer. */
export const BRAND_NAME = 'CodeKhmerLearning Community';
/** The two brands this platform brings together (shown as a small footnote). */
export const BRAND_LINE = 'CKL = CodeKhmerLearning · MiniShop = Ecommerce Multi shop';

export const BLUE_GRADIENT = `linear-gradient(135deg, ${BLUE} 0%, ${BLUE_DARK} 100%)`;
/** Mini Shop gradient (blue + orange) — used on the shops pages only. */
export const BRAND_GRADIENT = `linear-gradient(135deg, ${BLUE} 0%, ${BLUE_DARK} 58%, ${ORANGE} 135%)`;
/** Story ring: one colour family, blue shades (community is blue-only). */
export const STORY_RING = `conic-gradient(from 210deg, ${BLUE} 0%, ${BLUE_SOFT} 45%, ${BLUE_DARK} 100%)`;
/** Soft blue page tint used behind the community pages. */
export const PAGE_TINT = 'linear-gradient(180deg, #EAF1FF 0%, #F7FAFF 280px, #F7FAFF 100%)';

/** "3 minutes ago" style timestamps in Khmer or English. */
export function timeAgo(iso, lang = 'en') {
  if (!iso) return '';
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return '';
  const s = Math.max(0, Math.floor((Date.now() - then) / 1000));
  const km = lang === 'kh';
  if (s < 60) return km ? 'អម្បាញ់មិញ' : 'just now';
  const m = Math.floor(s / 60);
  if (m < 60) return km ? `${m} នាទីមុន` : `${m} min ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return km ? `${h} ម៉ោងមុន` : `${h} h ago`;
  const d = Math.floor(h / 24);
  if (d < 7) return km ? `${d} ថ្ងៃមុន` : `${d} d ago`;
  const date = new Date(iso);
  return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
}

/** First letters of a display name — used when a member has no avatar. */
export function initials(name) {
  const parts = String(name || '?').trim().split(/\s+/).slice(0, 2);
  return parts.map((p) => p[0]).join('').toUpperCase() || '?';
}

/** Deterministic colour for the avatar placeholder (brand-friendly). */
export function avatarColor(seed) {
  const palette = ['#011F46', '#FB6E08', '#0b2e5b', '#1d4ed8', '#0f766e', '#b45309', '#7c3aed'];
  const key = String(seed || '');
  let sum = 0;
  for (let i = 0; i < key.length; i += 1) sum += key.charCodeAt(i);
  return palette[sum % palette.length];
}

/** Number formatting (1.2K). */
export function compactNumber(n) {
  const v = Number(n) || 0;
  if (v < 1000) return `${v}`;
  if (v < 1000000) return `${(v / 1000).toFixed(v < 10000 ? 1 : 0)}K`;
  return `${(v / 1000000).toFixed(1)}M`;
}
